module.exports = require('./helpers/bundle-url').getBundleURL('2CT83') + "logo.c51670a8.svg";